<div
  class="content-padding status-badge"
  [class.badge-color-success]="type === 'success'"
  [class.badge-color-warning]="type === 'warning'"
  [class.badge-color-error]="type === 'error'"
  [class.badge-color-info]="type === 'info'"
  [class.cg-bold]="style === 'bold'"
  [class.cg-font-size-m]="size === 'medium'"
  [class.cg-font-size-ml]="size === 'large'"
  [attr.data-test-id]="'status-badge-' + type"
>
  <div *ngIf="hasIcon" style="display: inline-flex">
    <ng-leaf-icon-next
      *ngIf="type === 'success'"
      class="cg-margin-right-sm"
      name="success"
      category="system"
      weight="regular"
      [size]="size === 'small' ? '20' : size === 'large' ? '30' : '24'"
    ></ng-leaf-icon-next>
    <ng-leaf-icon-next
      *ngIf="type === 'error'"
      class="cg-margin-right-sm"
      name="error"
      category="system"
      weight="regular"
      [size]="size === 'small' ? '20' : size === 'large' ? '30' : '24'"
    ></ng-leaf-icon-next>
    <ng-leaf-icon-next
      *ngIf="type === 'warning'"
      class="cg-margin-right-sm"
      name="warning"
      category="system"
      weight="regular"
      [size]="size === 'small' ? '20' : size === 'large' ? '30' : '24'"
    ></ng-leaf-icon-next>
    <ng-leaf-icon-next
      *ngIf="type === 'info'"
      class="cg-margin-right-sm"
      name="info"
      category="system"
      weight="regular"
      [size]="size === 'small' ? '20' : size === 'large' ? '30' : '24'"
    ></ng-leaf-icon-next>
  </div>
  <div>{{ text }}</div>
</div>
